import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';
import {
	brandPrimaryHoverTint,
	brandPrimaryText,
	darkGrayFontColor,
	header,
	mention,
	shuffleGray,
	success,
	successTint,
} from '../../../styles/colors';
import { BreakPoints, CssSelectors, baseStyleSheet } from '../../../styles/styles';
const { colors, spacing } = THEME;

const MobileBreakpoint = 720;

export const styleSheet = StyleSheet.create({
	// Layout styles
	root: {
		flexDirection: 'column',
		width: '100%',
	},
	bodyColumns: {
		display: 'grid',
		gridTemplateColumns: 'minmax(210px, 1fr) 3fr',
		width: '100%',
		[BreakPoints.forMaxWidth(MobileBreakpoint)]: {
			display: 'flex',
			flexDirection: 'column',
		},
	},
	bodyFull: {
		backgroundColor: brandPrimaryHoverTint,
		borderRadius: 6,
		color: brandPrimaryText,
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-evenly',
		textAlign: 'center',
		width: '100%',
		[BreakPoints.forMinWidth(MobileBreakpoint)]: {
			height: 140,
			flexDirection: 'row',
		},
	},
	bodyLeft: {
		textAlign: 'center',
	},
	bodyRight: {
		display: 'grid',
		gridTemplateColumns: '24px 1fr 24px',
		gap: 8,
		width: '100%',
		[BreakPoints.forMaxWidth(MobileBreakpoint)]: {
			marginTop: 24,
		},
	},

	// Header styles
	cardHeader: {
		alignItems: 'center',
		borderBottom: `1px solid ${mention}`,
		color: header,
		display: 'flex',
		marginBottom: '1rem',
		paddingBottom: '0.5rem',
		textAlign: 'center',
		width: '100%',
	},
	headerColumns: {
		display: 'grid',
		gridTemplateColumns: 'minmax(210px, 1fr) 3fr',
		width: '100%',
		[BreakPoints.forMaxWidth(MobileBreakpoint)]: {
			gridTemplateColumns: '50% 50%',
		},
	},
	logo: {
		height: 24,
		marginRight: spacing.xs,
	},
	logoWrapper: {
		display: 'flex',
		alignItems: 'center',
	},
	ratingsTitle: {
		display: 'flex',
		alignItems: 'center',
		gap: spacing.sm,
		fontSize: 14,
		height: 24,
		marginTop: spacing.xs,
		marginLeft: 32,
	},
	ratingStar: {
		height: 12,
		width: 12,
	},

	reviewContainerWrapper: {
		display: 'flex',
		flexDirection: 'column',
		gap: 16,
	},
	reviewContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: 8,
		minHeight: 96,
	},
	// Review content styles
	author: {
		display: 'block',
		...baseStyleSheet.fontBold,
	},
	rating: {
		display: 'flex',
		flexDirection: 'row',
	},
	daysAgo: {
		alignSelf: 'flex-end',
		color: header,
		fontSize: 12,
		marginBottom: 2,
		marginLeft: 8,
	},
	location: {
		alignSelf: 'flex-end',
		color: darkGrayFontColor,
		fontSize: 12,
		marginBottom: 2,
		marginLeft: 8,
		fontStyle: 'italic',
	},
	reviewText: {
		maxHeight: 140,
		overflow: 'hidden',
		margin: 0,
		padding: 0,
		color: darkGrayFontColor,
	},

	// Navigation styles
	goBackButton: {
		marginTop: 42,
		textAlign: 'right',
	},
	goNextButton: {
		marginTop: 42,
		textAlign: 'left',
	},

	// Badge styles
	grayBadge: {
		background: shuffleGray,
		border: '1px solid rgba(167, 171, 173, 1)',
		padding: spacing.xs,
		fontSize: 12,
	},
	redBadge: {
		background: colors.danger.light,
		border: `1px solid ${colors.danger.main}`,
	},
	wideBadge: {
		paddingLeft: spacing.lg,
		paddingRight: spacing.lg,
	},

	// Stats styles
	percentIncreaseContainer: {
		padding: 16,
		display: 'table',
		margin: '0 auto',
	},
	percentIncreaseStat: {
		background: successTint,
		color: success,
		display: 'flex',
		flexDirection: 'column',
		maxWidth: 140,
		padding: '8px 24px 12px 24px',
		borderRadius: 6,
	},
	percentIncreaseTitle: {
		fontSize: 30,
		...baseStyleSheet.fontBold,
	},
	percentIncreaseSubtitle: {
		fontSize: 10,
	},

	// Empty state styles
	noReviewsImage: {
		overflow: 'hidden',
	},
	getMoreReviews: {
		background: 'transparent',
		textDecoration: 'none',
	},

	// Button container styles
	buttonContainer: {
		display: 'flex',
		...CssSelectors.allChildren(
			{
				marginLeft: spacing.sm,
			},
			':not(:first-child)'
		),
	},
	reviewTagsContainer: {
		minHeight: 30,
		display: 'flex',
		alignItems: 'center',
		gap: 8,
	},
});
